import { useDispatch, useSelector } from 'react-redux'
import Checkbox from '../../../../../UI/Checkbox/Checkbox'
import { getUUID } from '../../../../../../utility'
import defaultState from '../../../../../../reducer/defaultState'
import Input from '../../../../../UI/Input/Input'
import { setLocal } from '../../../../../../redux/action/local'
import props from '../../../../../../redux/props'

const MultiTenant = () => {
  const translations = useSelector((state) => state.translations)
  const purchaseProfile = useSelector((state) => state.PURCHASE_PROFILE)
  const dispatch = useDispatch()

  const update = (key) => (value) => {
    const mapping = {
      multiTenant: 'multiTenantMinRunningTime',
    }
    const values = {}
    if (value === false && mapping[key]) {
      values[mapping[key]] = defaultState.purchaseProfile[mapping[key]]
    }
    values[key] = value

    // dispatch(setNewPurchaseProfile({ ...purchaseProfile, ...values }))
    dispatch(setLocal(props.PURCHASE_PROFILE, { ...purchaseProfile, ...values }))
  }

  return (
    <div className="wrapper">
      <div className="group">
        <div className="values">
          <Checkbox key={getUUID()} checked={purchaseProfile.multiTenant} onChange={update('multiTenant')} text={translations['my-objects.pipeline.yield-and-object-criteria.multi-tenant']} />
        </div>
      </div>
      <div className="group">
        <div className="values">
          <Input
            type="customNumber"
            prefix={translations['min.symbol']}
            disabled={!purchaseProfile.multiTenant}
            value={purchaseProfile.multiTenantMinRunningTime}
            onChange={update('multiTenantMinRunningTime')}
            symbol={translations['years.symbol']}
            suffix={translations['remainingtime.symbol']}
          />
        </div>
      </div>
    </div>
  )
}

export default MultiTenant
